import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const AccessoriesPage = Loadable(
  lazy(() => import("../../MainAppView/Accessories/AccessoriesPage")),
);
const AccessoryViewPage = Loadable(
  lazy(() => import("../../MainAppView/Accessories/AccessoryViewPage")),
);
const AccessoryCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Accessories/AccessoryCreateUpdatePage")),
);
const ChargeCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Charges/ChargeCreateUpdatePage")),
);
const ChargeViewPage = Loadable(lazy(() => import("../../MainAppView/Charges/ChargeViewPage")));
const ChargesPage = Loadable(lazy(() => import("../../MainAppView/Charges/ChargesPage")));
const CustomTagCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Tags/CustomTags/CustomTagCreateUpdatePage")),
);
const CustomTagViewPage = Loadable(
  lazy(() => import("../../MainAppView/Tags/CustomTags/CustomTagViewPage")),
);
const CustomTagsPage = Loadable(
  lazy(() => import("../../MainAppView/Tags/CustomTags/CustomTagsPage")),
);
const PartyViewPage = Loadable(lazy(() => import("../../MainAppView/Party/Party/PartyViewPage")));
const SupplierCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Suppliers/SupplierCreateUpdatePage")),
);
const SupplierViewPage = Loadable(
  lazy(() => import("../../MainAppView/Suppliers/SupplierViewPage")),
);
const SuppliersPage = Loadable(lazy(() => import("../../MainAppView/Suppliers/SuppliersPage")));
const AssignmentsPage = Loadable(
  lazy(() => import("../../MainAppView/Assignments/AssignmentsPage")),
);
const AssignmentCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Assignments/AssignmentCreateUpdatePage")),
);
const AssignmentViewPage = Loadable(
  lazy(() => import("../../MainAppView/Assignments/AssignmentViewPage")),
);

export function OtherRoutes() {
  return (
    <>
      {/* Accessory */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AccessoryRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ACCESSORIES)}
        render={() => <AccessoriesPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AccessoryManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ACCESSORY_CREATE)}
        render={() => <AccessoryCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AccessoryManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ACCESSORY_EDIT())}
        render={() => <AccessoryCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AccessoryRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ACCESSORY_VIEW())}
        render={() => <AccessoryViewPage />}
      />

      {/* CustomTag */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.CustomTagRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CUSTOM_TAGS)} //
        render={() => <CustomTagsPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.CustomTagRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CUSTOM_TAG_VIEW())}
        render={() => <CustomTagViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.CustomTagManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CUSTOM_TAG_CREATE())}
        render={() => <CustomTagCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.CustomTagManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CUSTOM_TAG_EDIT())}
        render={() => <CustomTagCreateUpdatePage />}
      />

      {/* Charge */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.ChargeRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CHARGES)} //
        render={() => <ChargesPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.ChargeRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CHARGE_VIEW())}
        render={() => <ChargeViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.ChargeManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CHARGE_CREATE())}
        render={() => <ChargeCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.ChargeManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.CHARGE_EDIT())}
        render={() => <ChargeCreateUpdatePage />}
      />

      {/* Party */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.PARTY_VIEW())}
        render={() => <PartyViewPage />}
      />

      {/* Supplier */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.SupplierRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.SUPPLIERS)}
        render={() => <SuppliersPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.SupplierRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.SUPPLIER_VIEW())}
        render={() => <SupplierViewPage />}
      />

      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.SupplierManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.SUPPLIER_CREATE)}
        render={() => <SupplierCreateUpdatePage />}
      />

      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.SupplierManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.SUPPLIER_EDIT())}
        render={() => <SupplierCreateUpdatePage />}
      />

      {/* Assignment */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AssignmentRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ASSIGNMENTS)}
        render={() => <AssignmentsPage />}
      />

      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AssignmentRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ASSIGNMENT_VIEW())}
        render={() => <AssignmentViewPage />}
      />

      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AssignmentManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ASSIGNMENT_CREATE())}
        render={() => <AssignmentCreateUpdatePage />}
      />

      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.AssignmentManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ASSIGNMENT_EDIT())}
        render={() => <AssignmentCreateUpdatePage />}
      />
    </>
  );
}
